import Button from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip';
import React, { Suspense } from 'react';
import { ForwardedRefToolTipTag } from './forward-ref-tooltip-tag';
import { LabelContainer, PrimaryButtonStyledLink, PrimaryButtonWrapper, SearchFooterLinksContainer } from './search-footer-links.styled';
var DropDownLinks = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/search-dialog/search-footer/dropdown-links" */'./drop-down-links').then(function (module) {
    return {
      default: module.default
    };
  });
});
var DEFAULT_MAX_PRIMARY_LINKS = 5;
export var SearchFooterLinks = function SearchFooterLinks(_ref) {
  var label = _ref.label,
    links = _ref.links,
    dropdownTriggerLabel = _ref.dropdownTriggerLabel,
    _onClick = _ref.onClick,
    linkComponent = _ref.linkComponent,
    maxPrimaryLinks = _ref.maxPrimaryLinks;
  var primaryLinks = links.slice(0, maxPrimaryLinks || DEFAULT_MAX_PRIMARY_LINKS);
  var dropdownLinks = links.slice(maxPrimaryLinks || DEFAULT_MAX_PRIMARY_LINKS, links.length);
  return /*#__PURE__*/React.createElement(SearchFooterLinksContainer, null, /*#__PURE__*/React.createElement(LabelContainer, null, label), primaryLinks.map(function (link) {
    var key = link.key,
      href = link.href,
      content = link.content;
    return /*#__PURE__*/React.createElement(PrimaryButtonWrapper, {
      key: key,
      onClick: function onClick(e) {
        return _onClick && _onClick(link, e);
      }
    }, /*#__PURE__*/React.createElement(PrimaryButtonStyledLink, {
      href: href,
      linkComponent: linkComponent
    }, /*#__PURE__*/React.createElement(Tooltip, {
      content: content,
      tag: ForwardedRefToolTipTag
    }, /*#__PURE__*/React.createElement(Button, {
      spacing: "compact",
      tabIndex: -1
    }, content))));
  }), dropdownLinks && dropdownLinks.length > 0 ? /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(DropDownLinks, {
    dropdownLinks: dropdownLinks,
    dropdownTriggerLabel: dropdownTriggerLabel,
    onClick: _onClick,
    linkComponent: linkComponent
  })) : null);
};